import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
// reactstrap components
import { ModalBody, Modal, ModalHeader, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import {
  IToolbarContentConfig,
  IToolbarLanguageConfig,
} from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import SidebarOdgButton from "../buttons/SidebarOdgButton";
import NoteButtonsContainer from "../containers/NoteButtonsContainer";
import LanguageDropdown from "../dropdowns/LanguageDropdown";
import SidebarLinksComponent from "../widgets/SidebarLinksComponent";
import SurveyButton from "../buttons/SidebarSurveyButton";
import RepositoryButton from "../buttons/SidebarRepositoryButton";
import SidebarArchiveButton from "../buttons/SidebarArchiveButton";

interface IParams {
  tenant: ITenant;
  currentUrl?: string;
  goBack: () => void;
}

const MobileSidebarModal: React.FC<IParams> = ({
  tenant,
  currentUrl,
  goBack,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { isSidebarModalOpen, setIsSidebarModalOpen } =
    rootStore.responsiveStore;
  const { theme, isOfflineModeEnabled } = rootStore.commonStore;

  const [t] = useTranslation(["browse_page"], translationHookOptions);
  const {
    toolbar,
    currentBrowsePageContent,
    currentGalleryPage,
    setGalleryPage,
  } = rootStore.commonStore;

  return (
    <>
      <Modal
        isOpen={isSidebarModalOpen}
        toggle={() => setIsSidebarModalOpen(!isSidebarModalOpen)}
        className={classNames("homeModal modal-dialog-centered ")}
        contentClassName="customHomeModalContent "
      >
        <ModalHeader
          className={classNames(
            "homeModalHeader ",
            theme!.headerColor,
            theme!.headerTextColor
          )}
          toggle={() => setIsSidebarModalOpen(!isSidebarModalOpen)}
          close={
            <button
              className={classNames(
                "closeHomeModalIcon",
                theme!.headerTextColor
              )}
              onClick={() => setIsSidebarModalOpen(!isSidebarModalOpen)}
            >
              <i className="far fa-times-circle fa-lg"></i>
            </button>
          }
        >
          {t("sidebar_modal_title")}
        </ModalHeader>
        <ModalBody className={classNames("customHomeModal",  theme!.sidebarColor ) }>
            <div>
          {!isOfflineModeEnabled ? (
            <SidebarOdgButton
              tenant={tenant}
              currentUrl={currentUrl}
            ></SidebarOdgButton>
          ) : null}

          <SidebarLinksComponent tenant={tenant} currentUrl={currentUrl} />

          {/* {!isOfflineModeEnabled && <SurveyButton />} */}

          <RepositoryButton tenant={tenant} currentUrl={currentUrl} />
          <SidebarArchiveButton tenant={tenant} currentUrl={currentUrl} />
            </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default observer(MobileSidebarModal);
